import { render, staticRenderFns } from "./UserDetailOverlay.vue?vue&type=template&id=460c4308&scoped=true"
import script from "./UserDetailOverlay.vue?vue&type=script&lang=js"
export * from "./UserDetailOverlay.vue?vue&type=script&lang=js"
import style0 from "./UserDetailOverlay.vue?vue&type=style&index=0&id=460c4308&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460c4308",
  null
  
)

export default component.exports